import { useContext } from 'react';

import { PollingContext } from 'common/components/withPollingContext/PollingContextProvider';

export function usePollingContextActions() {
  const { actions } = useContext(PollingContext);

  return actions;
}
